export default {
    "label.update_translations_unsuccessful": "label.update_translations_unsuccessful",
    "global.no_records": "global.no_records",
    "notifications.rp_has_been_updated": "notifications.rp_has_been_updated",
    "moduleTitle.files": "moduleTitle.files",
    "label.coordinator": "label.coordinator",
    "sidebar.translations_managment": "sidebar.translations_managment",
    "table.file": "table.file",
    "label.report_overview": "label.report_overview",
    "label.parent_agreement": "label.parent_agreement",
    "parentalConsent.i_consent_to_and_understand_that": "parentalConsent.i_consent_to_and_understand_that",
    "parentalConsent.i_understand_that_participants_are_required_to_comply": "parentalConsent.i_understand_that_participants_are_required_to_comply",
    "table.end_date": "table.end_date",
    "label.activation_date": "label.activation_date",
    "label.report": "label.report",
    "label.award_is_offline": "label.award_is_offline",
    "label.pending_changes": "label.pending_changes",
    "errors.min_nights_required": "errors.min_nights_required",
    "label.country": "label.country",
    "notifications.award_leader_has_been_returned": "notifications.award_leader_has_been_returned",
    "notifications.participant_has_been_updated": "notifications.participant_has_been_updated",
    "label.phone_number": "label.phone_number",
    "roles.aj_assessor": "roles.aj_assessor",
    "notifications.person_state_has_been_changed": "notifications.person_state_has_been_changed",
    "pageTitle.dashboard": "pageTitle.dashboard",
    "moduleTitle.global_payment_method": "moduleTitle.global_payment_method",
    "label.organization_type": "label.organization_type",
    "button.account_settings": "button.account_settings",
    "notifications.contact_has_been_updated": "notifications.contact_has_been_updated",
    "participant.recover_password": "participant.recover_password",
    "notifications.assessment_request_has_been_sent": "notifications.assessment_request_has_been_sent",
    "button.unassign": "button.unassign",
    "label.start_date": "label.start_date",
    "label.assign_labels": "label.assign_labels",
    "sidebar.participants": "sidebar.participants",
    "roles.coordinator": "roles.coordinator",
    "label.organization_contact": "label.organization_contact",
    "tabs.customization": "tabs.customization",
    "sidebar.award_units": "sidebar.award_units",
    "button.change_goal": "button.change_goal",
    "translationsManagement.selectProject": "translationsManagement.selectProject",
    "award.rp": "award.rp",
    "label.size": "label.size",
    "label.bulk_action_results": "label.bulk_action_results",
    "notifications.activity_has_been_approved": "notifications.activity_has_been_approved",
    "label.payment_type": "label.payment_type",
    "button.gop_assignment": "button.gop_assignment",
    "button.resend_assessment_request": "button.resend_assessment_request",
    "notifications.template_has_been_removed": "notifications.template_has_been_removed",
    "button.award_settings": "button.award_settings",
    "pageTitle.payment": "pageTitle.payment",
    "tasks.return_award": "tasks.return_award",
    "label.link": "label.link",
    "moduleTitle.award_participant_delete": "moduleTitle.award_participant_delete",
    "pageTitle.mro_related_contacts": "pageTitle.mro_related_contacts",
    "pageTitle.my_organization_labels": "pageTitle.my_organization_labels",
    "tabs.activity_signoff": "tabs.activity_signoff",
    "table.logs": "table.logs",
    "moduleTitle.remove_file": "moduleTitle.remove_file",
    "label.email_confirmed": "label.email_confirmed",
    "notifications.activity_has_been_returned": "notifications.activity_has_been_returned",
    "label.note": "label.note",
    "button.show": "button.show",
    "tabs.adventurous_journey": "tabs.adventurous_journey",
    "sidebar.my_todolist": "sidebar.my_todolist",
    "label.here": "label.here",
    "organisation.change_award_mode": "organisation.change_award_mode",
    "table.note_from_al": "table.note_from_al",
    "label.gender": "label.gender",
    "moduleTitle.remove": "moduleTitle.remove",
    "errors.must_be_less_than": "errors.must_be_less_than",
    "button.logout": "button.logout",
    "label.no_selected_participants": "label.no_selected_participants",
    "button.new_aj_event": "button.new_aj_event",
    "label.employement_status": "label.employement_status",
    "tabs.logs": "tabs.logs",
    "tabs.contacts": "tabs.contacts",
    "label.option": "label.option",
    "dashboard.charts": "dashboard.charts",
    "notifications.rp_has_been_approved": "notifications.rp_has_been_approved",
    "pageTitle.new_participant": "pageTitle.new_participant",
    "notifications.award_leader_has_been_approved": "notifications.award_leader_has_been_approved",
    "moduleTitle.would_you_like_to_remove_leader_training": "moduleTitle.would_you_like_to_remove_leader_training",
    "moduleTitle.update_configuration_value": "moduleTitle.update_configuration_value",
    "table.description": "table.description",
    "table.organization": "table.organization",
    "label.youtube": "label.youtube",
    "label.author": "label.author",
    "table.suitable_for_award_level": "table.suitable_for_award_level",
    "label.content_update": "label.content_update",
    "notifications.new_question_has_been_added": "notifications.new_question_has_been_added",
    "pageTitle.nao_awards": "pageTitle.nao_awards",
    "table.last_name": "table.last_name",
    "moduleTitle.adventurous_journey_detail": "moduleTitle.adventurous_journey_detail",
    "Description of the combo box selection in bulk operation panel": {"label.bulk_operations": "label.bulk_operations"},
    "label.project_location_type": "label.project_location_type",
    "label.email_help_award_level": "label.email_help_award_level",
    "label.date": "label.date",
    "label.previous_completed_award_place": "label.previous_completed_award_place",
    "button.show_more": "button.show_more",
    "label.wwc_number": "label.wwc_number",
    "button.filter": "button.filter",
    "notifications.rp_has_been_returned": "notifications.rp_has_been_returned",
    "pageTitle.residetial_project_assessor_report": "pageTitle.residetial_project_assessor_report",
    "label.generating": "label.generating",
    "moduleTitle.finance_system_data": "moduleTitle.finance_system_data",
    "notifications.adventurous_journey_state_has_been_changed": "notifications.adventurous_journey_state_has_been_changed",
    "route.levels": "route.levels",
    "moduleTitle.activity_leader": "moduleTitle.activity_leader",
    "tasks.approve_event": "tasks.approve_event",
    "tasks.reject_event": "tasks.reject_event",
    "table.region": "table.region",
    "pageTitle.nao_award_leaders": "pageTitle.nao_award_leaders",
    "errors.must_be_at_least": "errors.must_be_at_least",
    "table.title": "table.title",
    "table.last_activity": "table.last_activity",
    "tasks.delete_registration": "tasks.delete_registration",
    "table.date_time": "table.date_time",
    "parentalConsent.the_award_operators_are_committed_to_respecting": "parentalConsent.the_award_operators_are_committed_to_respecting",
    "aj.practice_journey": "aj.practice_journey",
    "notification.log_has_been_restored": "notification.log_has_been_restored",
    "tabs.my_participants": "tabs.my_participants",
    "label.bulk_action_assign_label": "label.bulk_action_assign_label",
    "moduleTitle.supervisor": "moduleTitle.supervisor",
    "moduleTitle.your_parental_consent": "moduleTitle.your_parental_consent",
    "route.registration_participants": "route.registration_participants",
    "placeholder.start_typing": "placeholder.start_typing",
    "tasks.approve_award": "tasks.approve_award",
    "route.registrations": "route.registrations",
    "button.add_activity": "button.add_activity",
    "notifications.aj_event_has_been_created": "notifications.aj_event_has_been_created",
    "states.supervisor_approval": "states.supervisor_approval",
    "label.description": "label.description",
    "button.leave_anyway": "button.leave_anyway",
    "tabs.registrations": "tabs.registrations",
    "states.leader_signoff": "states.leader_signoff",
    "moduleTitle.forbidden": "moduleTitle.forbidden",
    "notifications.translations_has_been_updated.button": "notifications.translations_has_been_updated.button",
    "pageTitle.nao_registration": "pageTitle.nao_registration",
    "pageTitle.mro_logs": "pageTitle.mro_logs",
    "meta.page_not_found": "meta.page_not_found",
    "label.bulk_action_unsuccessful": "label.bulk_action_unsuccessful",
    "global.days": "global.days",
    "table.review": "table.review",
    "table.as_assessor_for": "table.as_assessor_for",
    "roles.if_staff_statistical_user": "roles.if_staff_statistical_user",
    "table.levels": "table.levels",
    "label.suitable_for_level": "label.suitable_for_level",
    "pageTitle.leaders": "pageTitle.leaders",
    "moduleTitle.send_test_email": "moduleTitle.send_test_email",
    "pageTitle.tasks_removed_registration": "pageTitle.tasks_removed_registration",
    "label.you_will_be_forced_to_login_again_after_change": "label.you_will_be_forced_to_login_again_after_change",
    "table.recent_updates": "table.recent_updates",
    "pageTitle.tasks_activity_signoffs": "pageTitle.tasks_activity_signoffs",
    "pageTitle.payments": "pageTitle.payments",
    "global.nights": "global.nights",
    "label.blank_any_level": "label.blank_any_level",
    "button.view_section": "button.view_section",
    "moduleTitle.select_organization": "moduleTitle.select_organization",
    "pageTitle.manual_data_import": "pageTitle.manual_data_import",
    "button.upload_files": "button.upload_files",
    "label.migrated_contact_email": "label.migrated_contact_email",
    "label.for_award_unit": "label.for_award_unit",
    "label.aj_template_note": "label.aj_template_note",
    "table.last_log_added": "table.last_log_added",
    "button.view_participant": "button.view_participant",
    "label.please_comment_on_the_participants": "label.please_comment_on_the_participants",
    "label.consent_already_given_login": "label.consent_already_given_login",
    "participant.level_start_date": "participant.level_start_date",
    "sidebar.my_region_office": "sidebar.my_region_office",
    "states.section_signoff": "states.section_signoff",
    "moduleTitle.assessor_details": "moduleTitle.assessor_details",
    "moduleTitle.adventurous_journey_settings": "moduleTitle.adventurous_journey_settings",
    "moduleTitle.note_from_al": "moduleTitle.note_from_al",
    "button.add_role": "button.add_role",
    "table.run": "table.run",
    "states.change_to_state_warning_missing_assessment": "states.change_to_state_warning_missing_assessment",
    "label.user_app_guide_leader": "label.user_app_guide_leader",
    "tabs.section_approval": "tabs.section_approval",
    "roles.award_verifier": "roles.award_verifier",
    "tabs.activity_approval": "tabs.activity_approval",
    "logs.add_log": "logs.add_log",
    "tabs.award": "tabs.award",
    "notifications.this_role_has_read_only_persmission": "notifications.this_role_has_read_only_persmission",
    "table.no_filtered_results": "table.no_filtered_results",
    "button.praise": "button.praise",
    "label.prevent_welcome_email_assessor": "label.prevent_welcome_email_assessor",
    "label.location_detail": "label.location_detail",
    "label.optional": "label.optional",
    "errors.do_not_match": "errors.do_not_match",
    "label.use_comma_for_multiple_entries": "label.use_comma_for_multiple_entries",
    "label.operating_authority": "label.operating_authority",
    "label.activity_section": "label.activity_section",
    "notifications.you_have_been_logged_out": "notifications.you_have_been_logged_out",
    "table.finished": "table.finished",
    "button.same_as_billing": "button.same_as_billing",
    "table.payment": "table.payment",
    "table.current_level": "table.current_level",
    "button.view_nao": "button.view_nao",
    "table.email_confirmation": "table.email_confirmation",
    "moduleTitle.shipping_address": "moduleTitle.shipping_address",
    "label.secondary_phone_type": "label.secondary_phone_type",
    "notifications.saved": "notifications.saved",
    "pageTitle.all_participants": "pageTitle.all_participants",
    "label.first_name": "label.first_name",
    "label.oa_price": "label.oa_price",
    "table.award_mode": "table.award_mode",
    "tabs.api_keys": "tabs.api_keys",
    "award.award_detail": "award.award_detail",
    "tabs.user_management": "tabs.user_management",
    "tabs.all_events": "tabs.all_events",
    "notifications.history_record_has_been_removed": "notifications.history_record_has_been_removed",
    "award.no_data": "award.no_data",
    "notifications.preparation_training_has_been_added": "notifications.preparation_training_has_been_added",
    "label.message": "label.message",
    "notifications.participant_info_updated": "notifications.participant_info_updated",
    "roles.nao_staff": "roles.nao_staff",
    "tabs.adventurous_journeys": "tabs.adventurous_journeys",
    "label.gops": "label.gops",
    "route.upload": "route.upload",
    "notifications.history_record_has_been_added": "notifications.history_record_has_been_added",
    "notifications.history_record_has_been_updated": "notifications.history_record_has_been_updated",
    "label.no_data": "label.no_data",
    "button.add_coordinator": "button.add_coordinator",
    "label.you_are_already_logged_as": "label.you_are_already_logged_as",
    "route.my_national_office": "route.my_national_office",
    "tabs.leaders": "tabs.leaders",
    "label.email_confirmation": "label.email_confirmation",
    "table.registration_date": "table.registration_date",
    "notifications.role_has_been_removed": "notifications.role_has_been_removed",
    "button.move": "button.move",
    "label.terms_and_conditions": "label.terms_and_conditions",
    "pageTitle.detail": "pageTitle.detail",
    "table.award_unit": "table.award_unit",
    "sidebar.settings": "sidebar.settings",
    "dashboard.leader_state": "dashboard.leader_state",
    "notifications.award_unit_has_been_approved": "notifications.award_unit_has_been_approved",
    "states.awaiting_approval": "states.awaiting_approval",
    "table.level": "table.level",
    "table.action_requested": "table.action_requested",
    "label.organisation_mode": "label.organisation_mode",
    "label.no_note": "label.no_note",
    "tabs.my_events": "tabs.my_events",
    "notifications.participants_have_been_added": "notifications.participants_have_been_added",
    "tabs.registration_questions": "tabs.registration_questions",
    "button.delete_registration": "button.delete_registration",
    "notifications.parental_consent_link_has_been_sent": "notifications.parental_consent_link_has_been_sent",
    "moduleTitle.select_role_organization": "moduleTitle.select_role_organization",
    "label.experience": "label.experience",
    "translationsManagement.modal.title": "translationsManagement.modal.title",
    "table.ic": "table.ic",
    "table.id": "table.id",
    "label.notify_email_explanation": "label.notify_email_explanation",
    "participant.would_you_like_to_remove": "participant.would_you_like_to_remove",
    "table.fields_included": "table.fields_included",
    "label.user_guide_web_leader": "label.user_guide_web_leader",
    "label.journey_type": "label.journey_type",
    "button.setup": "button.setup",
    "tabs.my_national_office": "tabs.my_national_office",
    "notifications.training_has_been_removed": "notifications.training_has_been_removed",
    "label.nominated_and_identified_persons": "label.nominated_and_identified_persons",
    "moduleTitle.you_have_been_logged_out_due_to_inactivity": "moduleTitle.you_have_been_logged_out_due_to_inactivity",
    "states.award_leader_signoff": "states.award_leader_signoff",
    "table.award_signoff_attempts": "table.award_signoff_attempts",
    "sidebar.regions": "sidebar.regions",
    "label.activity_deleted_note": "label.activity_deleted_note",
    "table.total": "table.total",
    "errors.a_problem_has_occured_during_processing": "errors.a_problem_has_occured_during_processing",
    "participant.participant_already_has_gold_award": "participant.participant_already_has_gold_award",
    "pageTitle.mro": "pageTitle.mro",
    "notifications.authorization_code_has_expired": "notifications.authorization_code_has_expired",
    "moduleTitle.child_organization_labels": "moduleTitle.child_organization_labels",
    "aj.aj_events": "aj.aj_events",
    "global.loading": "global.loading",
    "label.gnipp": "label.gnipp",
    "sidebar.registrations": "sidebar.registrations",
    "label.any_string": "label.any_string",
    "contact.change_contact_status": "contact.change_contact_status",
    "tabs.registration": "tabs.registration",
    "label.override_payment_note": "label.override_payment_note",
    "notifications.section_has_been_signed_off": "notifications.section_has_been_signed_off",
    "label.payment_date": "label.payment_date",
    "button.approve": "button.approve",
    "moduleTitle.loggin_in": "moduleTitle.loggin_in",
    "label.website": "label.website",
    "label.role": "label.role",
    "table.assessor_report": "table.assessor_report",
    "label.ue_fe": "label.ue_fe",
    "label.please_comment_on_the_participants_effort": "label.please_comment_on_the_participants_effort",
    "label.previously_worked_as_assessor": "label.previously_worked_as_assessor",
    "pageTitle.registrations": "pageTitle.registrations",
    "parentalConsent.this_form_must_be_completed": "parentalConsent.this_form_must_be_completed",
    "button.apply": "button.apply",
    "errors.include_at_least_one_number": "errors.include_at_least_one_number",
    "label.content_restore": "label.content_restore",
    "logs.hour": "logs.hour",
    "parentalConsent.i_have_read_and_understand": "parentalConsent.i_have_read_and_understand",
    "notifications.award_was_deleted": "notifications.award_was_deleted",
    "label.journey_category": "label.journey_category",
    "notifications.search_cancelled": "notifications.search_cancelled",
    "route.detail": "route.detail",
    "route.user_guide": "route.user_guide",
    "moduleTitle.history": "moduleTitle.history",
    "table.gop_name": "table.gop_name",
    "pageTitle.tasks_unassigned_participants": "pageTitle.tasks_unassigned_participants",
    "states.inactive": "states.inactive",
    "pageTitle.search_results": "pageTitle.search_results",
    "button.proceed_to_login": "button.proceed_to_login",
    "pageTitle.assessor_report_reject": "pageTitle.assessor_report_reject",
    "notifications.contact_has_been_removed": "notifications.contact_has_been_removed",
    "sidebar.operating_authorities": "sidebar.operating_authorities",
    "label.no_note_from_participant": "label.no_note_from_participant",
    "aj.preparation_and_training": "aj.preparation_and_training",
    "route.user_guide_web_leader": "route.user_guide_web_leader",
    "label.position_in_organization": "label.position_in_organization",
    "errors.emails_dont_match": "errors.emails_dont_match",
    "route.my_participants": "route.my_participants",
    "pageTitle.customisations": "pageTitle.customisations",
    "tabs.localization_files": "tabs.localization_files",
    "table.assessor_approval": "table.assessor_approval",
    "tabs.related_contacts": "tabs.related_contacts",
    "table.aus": "table.aus",
    "table.category": "table.category",
    "errors.file_is_too_large": "errors.file_is_too_large",
    "label.possible_values": "label.possible_values",
    "label.if_your_download_doesnt_start": "label.if_your_download_doesnt_start",
    "route.independent_award_centres": "route.independent_award_centres",
    "pageTitle.user_guide": "pageTitle.user_guide",
    "button.visit": "button.visit",
    "label.hours_first_letter": "label.hours_first_letter",
    "pageTitle.my_organization_detail": "pageTitle.my_organization_detail",
    "pageTitle.nao_detail": "pageTitle.nao_detail",
    "button.change": "button.change",
    "award.aj": "award.aj",
    "table.award_state": "table.award_state",
    "pageTitle.tasks_award_signoff": "pageTitle.tasks_award_signoff",
    "pageTitle.regions": "pageTitle.regions",
    "notifications.award_has_been_signed_off": "notifications.award_has_been_signed_off",
    "dashboard.award_approved_by": "dashboard.award_approved_by",
    "tabs.new_template": "tabs.new_template",
    "error.parent_email_must_be_filled": "error.parent_email_must_be_filled",
    "label.organisation_invoicing_name": "label.organisation_invoicing_name",
    "pageTitle.related_contacts": "pageTitle.related_contacts",
    "button.try_again": "button.try_again",
    "label.cannot_be_change_to_another": "label.cannot_be_change_to_another",
    "notifications.lead_coordinator_has_been_set": "notifications.lead_coordinator_has_been_set",
    "label.training_name": "label.training_name",
    "moduleTitle.new_contact": "moduleTitle.new_contact",
    "translationsManagement.modal.updateTitle": "translationsManagement.modal.updateTitle",
    "moduleTitle.offline_award_units_signoff": "moduleTitle.offline_award_units_signoff",
    "notifications.award_level_has_been_changed": "notifications.award_level_has_been_changed",
    "label.subject": "label.subject",
    "route.silver_level": "route.silver_level",
    "label.privacy_notice": "label.privacy_notice",
    "label.switch_organization": "label.switch_organization",
    "meta.dofe_name": "meta.dofe_name",
    "route.profile": "route.profile",
    "roles.super_user": "roles.super_user",
    "dashboard.while_you_were_gone": "dashboard.while_you_were_gone",
    "label.no_note_from_award_leader": "label.no_note_from_award_leader",
    "label.middle_name": "label.middle_name",
    "moduleTitle.new_activity": "moduleTitle.new_activity",
    "organisation.would_you_like_to_remove": "organisation.would_you_like_to_remove",
    "label.state_province": "label.state_province",
    "moduleTitle.your_home_address": "moduleTitle.your_home_address",
    "tabs.sign_offs": "tabs.sign_offs",
    "moduleTitle.logs": "moduleTitle.logs",
    "button.view_more": "button.view_more",
    "label.profile": "label.profile",
    "label.title": "label.title",
    "tabs.award_signoff": "tabs.award_signoff",
    "label.post_code": "label.post_code",
    "states.ceremony_certificate": "states.ceremony_certificate",
    "label.code": "label.code",
    "parentalConsent.i_consent_to_the_provision_of_any": "parentalConsent.i_consent_to_the_provision_of_any",
    "label.user_guide_web_participant": "label.user_guide_web_participant",
    "label.award_unit_type": "label.award_unit_type",
    "states.complete": "states.complete",
    "table.participant_state": "table.participant_state",
    "pageTitle.my_organization_payment": "pageTitle.my_organization_payment",
    "table.approved": "table.approved",
    "pageTitle.my_organization_contacts": "pageTitle.my_organization_contacts",
    "warning.award_marked_as_paid_registration": "warning.award_marked_as_paid_registration",
    "states.change_to_state": "states.change_to_state",
    "label.integer": "label.integer",
    "notifications.translationUpdateInterrupted": "notifications.translationUpdateInterrupted",
    "notifications.password_has_been_changed": "notifications.password_has_been_changed",
    "button.invite_assessor": "button.invite_assessor",
    "label.other_activity": "label.other_activity",
    "notifications.parental_consent_has_been_sent": "notifications.parental_consent_has_been_sent",
    "button.revise": "button.revise",
    "errors.end_date_must_be_after_start_date": "errors.end_date_must_be_after_start_date",
    "label.award_leader_signoff_date": "label.award_leader_signoff_date",
    "parentalConsent.i_understand_every_participant_must": "parentalConsent.i_understand_every_participant_must",
    "moduleTitle.policies": "moduleTitle.policies",
    "pageTitle.tasks_aj": "pageTitle.tasks_aj",
    "global.day": "global.day",
    "moduleTitle.coordinator": "moduleTitle.coordinator",
    "label.region": "label.region",
    "button.add_history_record": "button.add_history_record",
    "moduleTitle.adventurous_journey_template_settings": "moduleTitle.adventurous_journey_template_settings",
    "notifications.personal_details_have_been_updated": "notifications.personal_details_have_been_updated",
    "sidebar.ics": "sidebar.ics",
    "table.independent_award_centre": "table.independent_award_centre",
    "label.undelivered_mail_reason": "label.undelivered_mail_reason",
    "table.utc_date_time": "table.utc_date_time",
    "moduleTitle.emails": "moduleTitle.emails",
    "label.backoffice": "label.backoffice",
    "moduleTitle.parent_consent": "moduleTitle.parent_consent",
    "label.photo_consent_given": "label.photo_consent_given",
    "moduleTitle.authorising_contact": "moduleTitle.authorising_contact",
    "label.assessment_with_role": "label.assessment_with_role",
    "dashboard.type_of_awards": "dashboard.type_of_awards",
    "moduleTitle.payment": "moduleTitle.payment",
    "states.in_progress": "states.in_progress",
    "logs.no_logs": "logs.no_logs",
    "sidebar.my_office": "sidebar.my_office",
    "label.assessor_report": "label.assessor_report",
    "notifications.rp_has_been_signed_off": "notifications.rp_has_been_signed_off",
    "tabs.labels": "tabs.labels",
    "sidebar.payments": "sidebar.payments",
    "meta.profile_questions": "meta.profile_questions",
    "label.fax": "label.fax",
    "label.email_help_custom_link": "label.email_help_custom_link",
    "label.last_name": "label.last_name",
    "organisation.manage_gop": "organisation.manage_gop",
    "table.parental_consent": "table.parental_consent",
    "dashboard.participant_by_level": "dashboard.participant_by_level",
    "tabs.award_leaders": "tabs.award_leaders",
    "label.i_confirm_that_ive_witnessed": "label.i_confirm_that_ive_witnessed",
    "table.lead_coordinator": "table.lead_coordinator",
    "states.deleted": "states.deleted",
    "label.no_answers": "label.no_answers",
    "button.add": "button.add",
    "label.exchequer_number": "label.exchequer_number",
    "label.waiting": "label.waiting",
    "label.email_help_person_full_name": "label.email_help_person_full_name",
    "tasks.return_registration": "tasks.return_registration",
    "notifications.state_aj_preparation_training_has_been_changed": "notifications.state_aj_preparation_training_has_been_changed",
    "label.parent_approval": "label.parent_approval",
    "table.assessor_approve": "table.assessor_approve",
    "errors.some_fields_requires_your_attention": "errors.some_fields_requires_your_attention",
    "aj.qualifying_journey": "aj.qualifying_journey",
    "route.awards": "route.awards",
    "table.registration": "table.registration",
    "pageTitle.assessors": "pageTitle.assessors",
    "notifications.award_has_been_updated": "notifications.award_has_been_updated",
    "errors.must_be_one_of": "errors.must_be_one_of",
    "pageTitle.logs": "pageTitle.logs",
    "notifications.notifications.invitation_has_been_sent": "notifications.notifications.invitation_has_been_sent",
    "route.national_offices": "route.national_offices",
    "notifications.training_has_been_updated": "notifications.training_has_been_updated",
    "label.parent_last_name": "label.parent_last_name",
    "table.leaders": "table.leaders",
    "states.award_level_complete": "states.award_level_complete",
    "button.reset": "button.reset",
    "sidebar.my_award_unit": "sidebar.my_award_unit",
    "pageTitle.all_aj_events": "pageTitle.all_aj_events",
    "label.activity": "label.activity",
    "moduleTitle.are_you_sure": "moduleTitle.are_you_sure",
    "route.gold_level": "route.gold_level",
    "table.evidence": "table.evidence",
    "label.delivery_confirmed": "label.delivery_confirmed",
    "parentalConsent.as_the_parent": "parentalConsent.as_the_parent",
    "label.awardMode.offline": "label.awardMode.offline",
    "tasks.approve_registration": "tasks.approve_registration",
    "note.change_the_email_will_change": "note.change_the_email_will_change",
    "notifications.participant_has_been_approved": "notifications.participant_has_been_approved",
    "label.reached_activity_limit": "label.reached_activity_limit",
    "label.facebook": "label.facebook",
    "notifications.label_has_been_removed": "notifications.label_has_been_removed",
    "label.action_required": "label.action_required",
    "notifications.preparation_training_has_been_removed": "notifications.preparation_training_has_been_removed",
    "pageTitle.settings": "pageTitle.settings",
    "participant.level_registration_date": "participant.level_registration_date",
    "notifications.question_has_been_removed": "notifications.question_has_been_removed",
    "label.email_help_award_leader_full_name": "label.email_help_award_leader_full_name",
    "sidebar.leaders": "sidebar.leaders",
    "notifications.participants_have_been_transferred": "notifications.participants_have_been_transferred",
    "tabs.assessors": "tabs.assessors",
    "sidebar.dashboard": "sidebar.dashboard",
    "pageTitle.independent_award_centers": "pageTitle.independent_award_centers",
    "label.search": "label.search",
    "moduleTitle.office_labels": "moduleTitle.office_labels",
    "label.note_from_participant": "label.note_from_participant",
    "errors.required_field": "errors.required_field",
    "tasks.approve_task": "tasks.approve_task",
    "logs.edit_log": "logs.edit_log",
    "table.state": "table.state",
    "moduleTitle.level_summary": "moduleTitle.level_summary",
    "moduleTitle.guides": "moduleTitle.guides",
    "modal.close": "modal.close",
    "label.parent_first_name": "label.parent_first_name",
    "parentalConsent.i_understand_that_the_participant": "parentalConsent.i_understand_that_the_participant",
    "tabs.award_units": "tabs.award_units",
    "table.hours": "table.hours",
    "label.type": "label.type",
    "notifications.adventurous_journey_has_been_removed": "notifications.adventurous_journey_has_been_removed",
    "label.aj_is_not_approved_yet": "label.aj_is_not_approved_yet",
    "roles.authorizing_contact": "roles.authorizing_contact",
    "table.date_submitted_to_office_signoff": "table.date_submitted_to_office_signoff",
    "notifications.section_has_been_returned": "notifications.section_has_been_returned",
    "table.created_by": "table.created_by",
    "route.user_guide_web_participant": "route.user_guide_web_participant",
    "route.templates": "route.templates",
    "states.awaiting_sign_off": "states.awaiting_sign_off",
    "table.phone": "table.phone",
    "label.parental_consent": "label.parental_consent",
    "label.org_contact_will_be_deleted": "label.org_contact_will_be_deleted",
    "route.bronze_level": "route.bronze_level",
    "label.invoice_currency": "label.invoice_currency",
    "button.new_label": "button.new_label",
    "error.server_cannot_be_reached_at_the_moment": "error.server_cannot_be_reached_at_the_moment",
    "notifications.contact_has_been_created": "notifications.contact_has_been_created",
    "pageTitle.profile_questions": "pageTitle.profile_questions",
    "table.observation_files": "table.observation_files",
    "table.participants": "table.participants",
    "tasks.no_evidence": "tasks.no_evidence",
    "button.edit": "button.edit",
    "moduleTitle.leader": "moduleTitle.leader",
    "notifications.new_template_has_been_updated": "notifications.new_template_has_been_updated",
    "table.name": "table.name",
    "label.no_results": "label.no_results",
    "moduleTitle.documents": "moduleTitle.documents",
    "button.invite": "button.invite",
    "label.goal": "label.goal",
    "pageTitle.nao_award_units": "pageTitle.nao_award_units",
    "label.award_delete_participant_id": "label.award_delete_participant_id",
    "errors.at_least_num_characters": "errors.at_least_num_characters",
    "label.email_help_note": "label.email_help_note",
    "label.person_status.activating": "label.person_status.activating",
    "moduleTitle.remove_role": "moduleTitle.remove_role",
    "label.total": "label.total",
    "label.delete_participant_award_info": "label.delete_participant_award_info",
    "route.leaders": "route.leaders",
    "table.start_date": "table.start_date",
    "moduleTitle.coordinators": "moduleTitle.coordinators",
    "button.create": "button.create",
    "tabs.awards": "tabs.awards",
    "parentalConsent.form_has_been_sent": "parentalConsent.form_has_been_sent",
    "states.journey_approval": "states.journey_approval",
    "pageTitle.reports": "pageTitle.reports",
    "table.journey_type": "table.journey_type",
    "label.yes": "label.yes",
    "pageTitle.assessor_report": "pageTitle.assessor_report",
    "label.organization": "label.organization",
    "notifications.award_leader_has_been_updated": "notifications.award_leader_has_been_updated",
    "moduleTitle.edit_role": "moduleTitle.edit_role",
    "table.journey_activity": "table.journey_activity",
    "label.location": "label.location",
    "label.update_translations_error_item": "label.update_translations_error_item",
    "pageTitle.adventurous_journeys": "pageTitle.adventurous_journeys",
    "global.assessor": "global.assessor",
    "moduleTitle.profile_questions": "moduleTitle.profile_questions",
    "activity.cannot_edit_activity_if_award_in_state": "activity.cannot_edit_activity_if_award_in_state",
    "moduleTitle.assessor_detail": "moduleTitle.assessor_detail",
    "parentalConsent.i_understand_that_upon_acceptance_into": "parentalConsent.i_understand_that_upon_acceptance_into",
    "notifications.award_has_been_returned": "notifications.award_has_been_returned",
    "label.code_of_conduct": "label.code_of_conduct",
    "button.new_contact": "button.new_contact",
    "tabs.payments": "tabs.payments",
    "roles.naa_oa_staff": "roles.naa_oa_staff",
    "label.switch_organisation_hint": "label.switch_organisation_hint",
    "label.expiration_date": "label.expiration_date",
    "tabs.participants": "tabs.participants",
    "table.practice": "table.practice",
    "notifications.one_activity_has_to_remain": "notifications.one_activity_has_to_remain",
    "label.qualifications": "label.qualifications",
    "states.organization_approval": "states.organization_approval",
    "errors.must_be_an_integer": "errors.must_be_an_integer",
    "participant.send_confirmation_email_again_question": "participant.send_confirmation_email_again_question",
    "button.dismiss": "button.dismiss",
    "table.advice": "table.advice",
    "label.years_of_working_experience": "label.years_of_working_experience",
    "notifications.search_failed": "notifications.search_failed",
    "notifications.changes_have_been_saved": "notifications.changes_have_been_saved",
    "moduleTitle.resend_parental_consent_link": "moduleTitle.resend_parental_consent_link",
    "label.activity_type": "label.activity_type",
    "label.change_award": "label.change_award",
    "label.email": "label.email",
    "button.remove": "button.remove",
    "button.download": "button.download",
    "label.vat_treatment": "label.vat_treatment",
    "pageTitle.aj_template_new": "pageTitle.aj_template_new",
    "table.per_page": "table.per_page",
    "notifications.translations_has_been_updated": "notifications.translations_has_been_updated",
    "notification.award_mode_has_been_updated": "notification.award_mode_has_been_updated",
    "tasks.revise_item": "tasks.revise_item",
    "button.resend_parental_consent": "button.resend_parental_consent",
    "table.weeks_completed_required": "table.weeks_completed_required",
    "label.last_modified": "label.last_modified",
    "table.major": "table.major",
    "label.vat_number": "label.vat_number",
    "errors.passwords_dont_match": "errors.passwords_dont_match",
    "table.country": "table.country",
    "sidebar.guides_and_policies": "sidebar.guides_and_policies",
    "notifications.question_has_been_updated": "notifications.question_has_been_updated",
    "table.participant_name": "table.participant_name",
    "label.registration_approval_date": "label.registration_approval_date",
    "notifications.auth_code_is_no_longer_valid": "notifications.auth_code_is_no_longer_valid",
    "errors.must_be_no_more_than": "errors.must_be_no_more_than",
    "notifications.event_has_been_rejected": "notifications.event_has_been_rejected",
    "tabs.customizations": "tabs.customizations",
    "label.name_organization": "label.name_organization",
    "button.add_log": "button.add_log",
    "moduleTitle.invite_assessor": "moduleTitle.invite_assessor",
    "label.resend_confirmation_email": "label.resend_confirmation_email",
    "text.all_participants_will_be_transfered": "text.all_participants_will_be_transfered",
    "label.repeat_email": "label.repeat_email",
    "errors.email_or_phone_required": "errors.email_or_phone_required",
    "notifications.role_has_been_updated": "notifications.role_has_been_updated",
    "roles.if_staff_stat_user": "roles.if_staff_stat_user",
    "participant.delete_account": "participant.delete_account",
    "moduleTitle.would_you_like_to_remove_this_log": "moduleTitle.would_you_like_to_remove_this_log",
    "sidebar.sgops": "sidebar.sgops",
    "label.prepare_new_email": "label.prepare_new_email",
    "table.journey_category": "table.journey_category",
    "sidebar.manual_data_import": "sidebar.manual_data_import",
    "label.created_after_date": "label.created_after_date",
    "route.my_organization": "route.my_organization",
    "button.show_list": "button.show_list",
    "label.leaders": "label.leaders",
    "notifications.log_has_been_modified": "notifications.log_has_been_modified",
    "button.upload_file": "button.upload_file",
    "moduleTitle.which_section_do_you_want_to": "moduleTitle.which_section_do_you_want_to",
    "tabs.bronze_level": "tabs.bronze_level",
    "notifications.participants_have_been_saved": "notifications.participants_have_been_saved",
    "pageTitle.aj_template_detail": "pageTitle.aj_template_detail",
    "label.parent_email": "label.parent_email",
    "map.appr_location": "map.appr_location",
    "notifications.log_has_been_removed": "notifications.log_has_been_removed",
    "notifications.label_has_been_assigned": "notifications.label_has_been_assigned",
    "pageTitle.tasks_undelivered_emails": "pageTitle.tasks_undelivered_emails",
    "button.stay": "button.stay",
    "table.previous_level": "table.previous_level",
    "label.award_start_date": "label.award_start_date",
    "assessor_report.returned_to_participant": "assessor_report.returned_to_participant",
    "pageTitle.tasks_assessors_registration": "pageTitle.tasks_assessors_registration",
    "aj.cannot_modify_award": "aj.cannot_modify_award",
    "moduleTitle.lost_internet_connection": "moduleTitle.lost_internet_connection",
    "states.ceremony": "states.ceremony",
    "participant.reactivate_account": "participant.reactivate_account",
    "label.birthdate": "label.birthdate",
    "pageTitle.assessment_send_successfully": "pageTitle.assessment_send_successfully",
    "states.assessor_approval": "states.assessor_approval",
    "award.change_award_level": "award.change_award_level",
    "label.url_no_longer_valid": "label.url_no_longer_valid",
    "button.update": "button.update",
    "label.secondary_email": "label.secondary_email",
    "button.role_edit": "button.role_edit",
    "table.award_leader": "table.award_leader",
    "label.level": "label.level",
    "tasks.evidence": "tasks.evidence",
    "notifications.participant_is_already_in_list": "notifications.participant_is_already_in_list",
    "button.clear": "button.clear",
    "label.allow_log_after_25_yoa": "label.allow_log_after_25_yo",
    "states.setup": "states.setup",
    "table.activity": "table.activity",
    "label.copy_to_clipboard": "label.copy_to_clipboard",
    "route.award_units": "route.award_units",
    "button.upload_photo": "button.upload_photo",
    "table.hours_completed_required": "table.hours_completed_required",
    "table.first_name": "table.first_name",
    "notifications.adventurous_journey_has_been_returned": "notifications.adventurous_journey_has_been_returned",
    "pageTitle.national_offices": "pageTitle.national_offices",
    "notifications.you_have_been_logged_in": "notifications.you_have_been_logged_in",
    "logs.offline": "logs.offline",
    "moduleTitle.add_role": "moduleTitle.add_role",
    "label.user_app_guide_participant": "label.user_app_guide_participant",
    "notifications.file_has_been_removed": "notifications.file_has_been_removed",
    "label.send_message": "label.send_message",
    "button.select": "button.select",
    "label.reason_of_deletion": "label.reason_of_deletion",
    "label.user_guide": "label.user_guide",
    "pageTitle.nao_participants": "pageTitle.nao_participants",
    "tabs.sub_operating_partners": "tabs.sub_operating_partners",
    "table.uploaded_by": "table.uploaded_by",
    "tasks.approve_item": "tasks.approve_item",
    "tasks.restore_participant_registration": "tasks.restore_participant_registration",
    "label.awardMode.hybrid": "label.awardMode.hybrid",
    "table.first_activity_started": "table.first_activity_started",
    "moduleTitle.dates": "moduleTitle.dates",
    "table.no_results": "table.no_results",
    "states.registration_approval": "states.registration_approval",
    "table.breakdown_of_hours": "table.breakdown_of_hours",
    "pageTitle.tasks_registration": "pageTitle.tasks_registration",
    "button.create_new": "button.create_new",
    "sidebar.todolist": "sidebar.todolist",
    "label.active_participants": "label.active_participants",
    "moduleTitle.postalAddress": "moduleTitle.postalAddress",
    "tasks.return_task": "tasks.return_task",
    "organisation.change_organisation_state": "organisation.change_organisation_state",
    "moduleTitle.roles": "moduleTitle.roles",
    "label.no_config_key_available": "label.no_config_key_available",
    "placeholder.selectLanguage": "placeholder.selectLanguage",
    "states.office_signoff": "states.office_signoff",
    "notifications.translations_has_been_updated.failure": "notifications.translations_has_been_updated.failure",
    "logs.minute": "logs.minute",
    "label.last_activity": "label.last_activity",
    "sidebar.user_guide": "sidebar.user_guide",
    "label.trained_award_leader": "label.trained_award_leader",
    "table.progress": "table.progress",
    "table.suboperating_authorities": "table.suboperating_authorities",
    "activity.cannot_edit_activity_offline": "activity.cannot_edit_activity_offline",
    "label.user_does_not_have_permissions": "label.user_does_not_have_permissions",
    "notifications.assessor_has_been_approved": "notifications.assessor_has_been_approved",
    "route.activity_approval": "route.activity_approval",
    "moduleTitle.role": "moduleTitle.role",
    "button.run": "button.run",
    "label.to": "label.to",
    "notifications.file_has_been_updated": "notifications.file_has_been_updated",
    "moduleTitle.edit_coordinator": "moduleTitle.edit_coordinator",
    "notifications.authorization_code_is_no_longer_valid": "notifications.authorization_code_is_no_longer_valid",
    "button.reject": "button.reject",
    "label.label.participant_status": "label.label.participant_status",
    "award.gold_level": "award.gold_level",
    "sidebar.variables": "sidebar.variables",
    "parentalConsent.checkbox_copy": "parentalConsent.checkbox_copy",
    "button.go_to_dashboard": "button.go_to_dashboard",
    "button.add_option": "button.add_option",
    "label.is_completed": "label.is_completed",
    "pageTitle.award_units": "pageTitle.award_units",
    "states.completed": "states.completed",
    "button.adventurous_journey_template_settings": "button.adventurous_journey_template_settings",
    "label.system_rights": "label.system_rights",
    "label.assessor_assesstment_award_start_date": "label.assessor_assesstment_award_start_date",
    "label.update_translation_question": "label.update_translation_question",
    "button.login": "button.login",
    "label.name_of_the_unit": "label.name_of_the_unit",
    "button.send": "button.send",
    "award.ajs": "award.ajs",
    "meta.payments_expired": "meta.payments_expired",
    "label.age": "label.age",
    "notifications.payment_info_updated": "notifications.payment_info_updated",
    "table.is_completed": "table.is_completed",
    "table.invited_by": "table.invited_by",
    "route.files": "route.files",
    "route.assessors": "route.assessors",
    "info.aj_supervisor_is_mandatory": "info.aj_supervisor_is_mandatory",
    "pageTitle.my_participants": "pageTitle.my_participants",
    "label.change_leader_status": "label.change_leader_status",
    "moduleTitle.parent_consent_form": "moduleTitle.parent_consent_form",
    "notifications.authorization_contact_has_been_set": "notifications.authorization_contact_has_been_set",
    "button.close": "button.close",
    "label.independent_country": "label.independent_country",
    "notifications.aj_preparation_training_has_been_returned": "notifications.aj_preparation_training_has_been_returned",
    "route.history_log": "route.history_log",
    "participant.account_settings": "participant.account_settings",
    "label.bulk_action_error_item": "label.bulk_action_error_item",
    "label.orb_account": "label.orb_account",
    "notifications.file_url_is_not_specified_in_configuration": "notifications.file_url_is_not_specified_in_configuration",
    "notifications.award_unit_has_been_removed": "notifications.award_unit_has_been_removed",
    "table.parent": "table.parent",
    "label.mode_of_transport": "label.mode_of_transport",
    "label.parental_consent_email_info": "label.parental_consent_email_info",
    "label.current_award": "label.current_award",
    "table.action": "table.action",
    "pageTitle.suboperating_authorities": "pageTitle.suboperating_authorities",
    "notifications.award_leader_has_been_assigned": "notifications.award_leader_has_been_assigned",
    "tabs.sign_offs_locally": "tabs.sign_offs_locally",
    "Activity log has been restored": "Activity log has been restored",
    "sidebar.naos": "sidebar.naos",
    "tabs.aj_templates": "tabs.aj_templates",
    "notifications.logging_out": "notifications.logging_out",
    "label.update_label": "label.update_label",
    "button.organisation_settings": "button.organisation_settings",
    "tabs.independent_award_centers": "tabs.independent_award_centers",
    "label.current": "label.current",
    "table.location": "table.location",
    "button.search": "button.search",
    "notifications.aj_preparation_training_has_been_approved": "notifications.aj_preparation_training_has_been_approved",
    "route.participants": "route.participants",
    "label.other_location_information": "label.other_location_information",
    "label.number_of_records": "label.number_of_records",
    "translationsManagement.infoLabel": "translationsManagement.infoLabel",
    "parentalConsent.i_consent_to_pay_all": "parentalConsent.i_consent_to_pay_all",
    "label.nationality": "label.nationality",
    "states.approval": "states.approval",
    "notifications.something_went_wrong": "notifications.something_went_wrong",
    "aj.practice": "aj.practice",
    "label.addressLine2": "label.addressLine2",
    "label.please_leave_a_note": "label.please_leave_a_note",
    "placeholder.select": "placeholder.select",
    "label.observations": "label.observations",
    "label.aim": "label.aim",
    "label.addressLine1": "label.addressLine1",
    "roles.aj_instructor": "roles.aj_instructor",
    "meta.payments_waiting": "meta.payments_waiting",
    "label.award_to_delete": "label.award_to_delete",
    "label.category": "label.category",
    "roles.instructor": "roles.instructor",
    "moduleTitle.remove_customization_and_reset": "moduleTitle.remove_customization_and_reset",
    "notifications.participant_registration_has_been_restored": "notifications.participant_registration_has_been_restored",
    "organisation.change_award_unit_mode": "organisation.change_award_unit_mode",
    "table.organization_type": "table.organization_type",
    "notifications.participant_has_been_deleted": "notifications.participant_has_been_deleted",
    "label.language_settings": "label.language_settings",
    "notifications.event_has_been_approved": "notifications.event_has_been_approved",
    "label.password": "label.password",
    "label.text": "label.text",
    "table.observations": "table.observations",
    "notifications.participant_has_been_created": "notifications.participant_has_been_created",
    "table.note_for_al": "table.note_for_al",
    "label.payment_confirmed": "label.payment_confirmed",
    "label.previous_completed_award_level": "label.previous_completed_award_level",
    "pageTitle.new_aj_event": "pageTitle.new_aj_event",
    "label.backend": "label.backend",
    "label.relationship_to_participant": "label.relationship_to_participant",
    "award.physical_recreation": "award.physical_recreation",
    "contact.collect_emails": "contact.collect_emails",
    "moduleTitle.assessor_report_reject": "moduleTitle.assessor_report_reject",
    "label.supervisor_report": "label.supervisor_report",
    "table.role": "table.role",
    "route.user_guide_web_nao": "route.user_guide_web_nao",
    "label.page_not_found": "label.page_not_found",
    "table.labels": "table.labels",
    "notifications.file_has_been_uploaded": "notifications.file_has_been_uploaded",
    "moduleTitle.address": "moduleTitle.address",
    "moduleTitle.lead_coordinator": "moduleTitle.lead_coordinator",
    "pageTitle.login": "pageTitle.login",
    "label.frontoffice": "label.frontoffice",
    "participant.would_you_like_to_remove_registration": "participant.would_you_like_to_remove_registration",
    "notifications.rp_has_been_setup": "notifications.rp_has_been_setup",
    "moduleTitle.award_unit": "moduleTitle.award_unit",
    "button.remove_file": "button.remove_file",
    "moduleTitle.billing_address": "moduleTitle.billing_address",
    "pageTitle.my_aj_events": "pageTitle.my_aj_events",
    "route.tasks": "route.tasks",
    "button.confirm": "button.confirm",
    "label.national_award_authority": "label.national_award_authority",
    "label.independent_award_centre": "label.independent_award_centre",
    "award.generate_award_report": "award.generate_award_report",
    "route.my_region_office_customization": "route.my_region_office_customization",
    "label.email_help_aj_category": "label.email_help_aj_category\n",
    "label.your_report_has_been_rejected": "label.your_report_has_been_rejected",
    "notifications.password_change_request_has_been_sent": "notifications.password_change_request_has_been_sent",
    "tabs.detail": "tabs.detail",
    "participant.change_participant_status": "participant.change_participant_status",
    "table.key": "table.key",
    "label.find_address": "label.find_address",
    "notifications.assessor_has_been_rejected": "notifications.assessor_has_been_rejected",
    "label.transfer_participants": "label.transfer_participants",
    "button.continue_to_payment_gateway": "button.continue_to_payment_gateway",
    "notifications.participant_registration_has_been_removed": "notifications.participant_registration_has_been_removed",
    "moduleTitle.page_not_found": "moduleTitle.page_not_found",
    "route.adventurous_journeys": "route.adventurous_journeys",
    "states.registration_assessment": "states.registration_assessment",
    "heading.change_award_unit_mode": "heading.change_award_unit_mode",
    "label.user_guide_web_nao": "label.user_guide_web_nao",
    "tabs.silver_level": "tabs.silver_level",
    "table.paid_by": "table.paid_by",
    "label.your_report_has_been_successfully_sent": "label.your_report_has_been_successfully_sent",
    "sidebar.my_organization": "sidebar.my_organization",
    "pageTitle.participants": "pageTitle.participants",
    "notifications.preparation_training_has_been_updated": "notifications.preparation_training_has_been_updated",
    "moduleTitle.server_is_unreachable": "moduleTitle.server_is_unreachable",
    "label.last_activity_date": "label.last_activity_date",
    "award.bronze_level": "award.bronze_level",
    "moduleTitle.award_units": "moduleTitle.award_units",
    "table.completed": "table.completed",
    "moduleTitle.revise_message": "moduleTitle.revise_message",
    "table.lastUsed": "table.lastUsed",
    "award.bronze_to_gold_level": "award.bronze_to_gold_level",
    "button.change_password": "button.change_password",
    "label.nao_price": "label.nao_price",
    "label.payment_state": "label.payment_state",
    "label.wwc_expired": "label.wwc_expired",
    "label.award_office_signoff_date": "label.award_office_signoff_date",
    "label.award_unit": "label.award_unit",
    "award.gold_level_short": "award.gold_level_short",
    "moduleTitle.other_info": "moduleTitle.other_info",
    "table.note": "table.note",
    "label.search_by_email_first_or_last": "label.search_by_email_first_or_last",
    "tabs.history": "tabs.history",
    "notifications.label_has_been_created": "notifications.label_has_been_created",
    "tabs.unassigned_participants": "tabs.unassigned_participants",
    "table.main_award_leader": "table.main_award_leader",
    "parentalConsent.i_as_the_parent": "parentalConsent.i_as_the_parent",
    "label.state": "label.state",
    "notifications.award_leader_has_been_removed": "notifications.award_leader_has_been_removed",
    "tabs.organization_detail": "tabs.organization_detail",
    "table.operating_authorities": "table.operating_authorities",
    "label.available_labels": "label.available_labels",
    "modal.select": "modal.select",
    "tabs.expired_payments": "tabs.expired_payments",
    "moduleTitle.note_for_al": "moduleTitle.note_for_al",
    "moduleTitle.confirm": "moduleTitle.confirm",
    "notification.new_activity_added": "notification.new_activity_added",
    "notifications.award_leader_has_been_moved": "notifications.award_leader_has_been_moved",
    "label.award_mode": "label.award_mode",
    "label.phone": "label.phone",
    "notifications.organization_has_been_updated": "notifications.organization_has_been_updated",
    "moduleTitle.assessor": "moduleTitle.assessor",
    "label.bulk_action_confirmation": "label.bulk_action_confirmation",
    "table.parent_approval": "table.parent_approval",
    "label.date_of_delivery": "label.date_of_delivery",
    "sidebar.assessors": "sidebar.assessors",
    "label.journey_activity": "label.journey_activity",
    "award.inactive_award": "award.inactive_award",
    "label.end_date": "label.end_date",
    "label.orb_testing": "label.orb_testing",
    "label.no_activities": "label.no_activities",
    "moduleTitle.please_confirm": "moduleTitle.please_confirm",
    "button.login_with_another_account": "button.login_with_another_account",
    "tasks.reject_registration": "tasks.reject_registration",
    "label.submitted_after_date": "label.submitted_after_date",
    "label.update_translations_successful": "label.update_translations_successful",
    "button.assign_leader": "button.assign_leader",
    "table.already_running": "table.already_running",
    "label.no": "label.no",
    "label.count_items_selected": "label.count_items_selected",
    "label.secondary_phone_number": "label.secondary_phone_number",
    "label.my_experience": "label.my_experience",
    "notifications.adventurous_journey_has_been_approved": "notifications.adventurous_journey_has_been_approved",
    "pageTitle.mro_detail": "pageTitle.mro_detail",
    "moduleTitle.nao_specific_info": "moduleTitle.nao_specific_info",
    "label.preparing_document_for_import": "label.preparing_document_for_import",
    "tasks.observations": "tasks.observations",
    "notifications.confirmation_email_has_been_sent": "notifications.confirmation_email_has_been_sent",
    "button.restore": "button.restore",
    "label.importing_file": "label.importing_file",
    "label.or_dont_agree": "label.or_dont_agree",
    "moduleTitle.award_leader": "moduleTitle.award_leader",
    "label.me": "label.me",
    "tabs.sub_global_operating_partners": "tabs.sub_global_operating_partners",
    "button.export_table": "button.export_table",
    "organisation.move_award_unit": "organisation.move_award_unit",
    "label.file_category": "label.file_category",
    "notifications.connecting_to_server": "notifications.connecting_to_server",
    "parentalConsent.i_understand_that_a_and_b": "parentalConsent.i_understand_that_a_and_b",
    "table.reason": "table.reason",
    "pageTitle.contacts": "pageTitle.contacts",
    "states.award_leader_approval": "states.award_leader_approval",
    "meta.payments": "meta.payments",
    "label.suboperating_authority": "label.suboperating_authority",
    "route.my_region_office": "route.my_region_office",
    "states.registration_not_approved": "states.registration_not_approved",
    "label.direct_entrant": "label.direct_entrant",
    "tabs.all_participants": "tabs.all_participants",
    "tabs.payment": "tabs.payment",
    "label.email_help_activity_name": "label.email_help_activity_name",
    "title.update_report": "title.update_report",
    "label.repeat_new_password": "label.repeat_new_password",
    "label.other_roles": "label.other_roles",
    "logs.hours": "logs.hours",
    "notifications.spreadsheet_has_been_imported_successfully": "notifications.spreadsheet_has_been_imported_successfully",
    "label.bulk_action_question": "label.bulk_action_question",
    "moduleTitle.personal_details": "moduleTitle.personal_details",
    "label.bulk_action_emailing": "label.bulk_action_emailing",
    "route.my_events": "route.my_events",
    "button.delete_award": "button.delete_award",
    "errors.include_both_lower_and_upper_case": "errors.include_both_lower_and_upper_case",
    "tabs.removed_participant_registrations": "tabs.removed_participant_registrations",
    "sidebar.mynao": "sidebar.mynao",
    "tabs.office_details": "tabs.office_details",
    "label.major": "label.major",
    "tabs.documents": "tabs.documents",
    "label.new_password": "label.new_password",
    "sidebar.adventure_journey": "sidebar.adventure_journey",
    "pageTitle.customizations": "pageTitle.customizations",
    "moduleTitle.assessor_report": "moduleTitle.assessor_report",
    "label.registration_date": "label.registration_date",
    "notifications.training_has_been_added": "notifications.training_has_been_added",
    "aj.qualifying": "aj.qualifying",
    "moduleTitle.you_have_been_logged_out_session_terminated": "moduleTitle.you_have_been_logged_out_session_terminated",
    "award.service": "award.service",
    "notifications.rp_state_has_been_changed": "notifications.rp_state_has_been_changed",
    "label.ctest_access": "label.ctest_access",
    "table.created": "table.created",
    "tasks.revise_task": "tasks.revise_task",
    "button.assign": "button.assign",
    "button.return": "button.return",
    "table.status": "table.status",
    "button.restore_activity": "button.restore_activity",
    "tabs.new_aj_event": "tabs.new_aj_event",
    "roles.if_staff_viewer": "roles.if_staff_viewer",
    "notifications.new_template_has_been_created": "notifications.new_template_has_been_created",
    "global.something_went_wrong": "global.something_went_wrong",
    "table.expire_day": "table.expire_day",
    "tabs.history_log": "tabs.history_log",
    "label.form_of_payment": "label.form_of_payment",
    "button.add_training": "button.add_training",
    "label.par_reg_cust_note": "label.par_reg_cust_note",
    "label.my_qualification": "label.my_qualification",
    "button.add_new_profile_question": "button.add_new_profile_question",
    "table.operating_authority": "table.operating_authority",
    "table.aim": "table.aim",
    "table.awards": "table.awards",
    "participant.deactivate_account": "participant.deactivate_account",
    "table.organization_name": "table.organization_name",
    "label.email_help_award_leader_first_name": "label.email_help_award_leader_first_name",
    "table.date": "table.date",
    "tasks.would_you_like_to_delete": "tasks.would_you_like_to_delete",
    "notifications.configuration_value_has_been_updated": "notifications.configuration_value_has_been_updated",
    "ajTemplates.fill_from_template": "ajTemplates.fill_from_template",
    "contact.send_test_email": "contact.send_test_email",
    "moduleTitle.aj_preparation_and_training": "moduleTitle.aj_preparation_and_training",
    "label.ce_be": "label.ce_be",
    "button.notify_participant": "button.notify_participant",
    "label.parent_phone": "label.parent_phone",
    "label.nao_regulations": "label.nao_regulations",
    "award.skills": "award.skills",
    "label.reject_application": "label.reject_application",
    "leader.delete_account": "leader.delete_account",
    "table.assign": "table.assign",
    "roles.aj_supervisor": "roles.aj_supervisor",
    "label.logout": "label.logout",
    "moduleTitle.award_leader_edit": "moduleTitle.award_leader_edit",
    "moduleTitle.training": "moduleTitle.training",
    "notifications.coordinator_has_been_removed": "notifications.coordinator_has_been_removed",
    "tabs.operating_partners": "tabs.operating_partners",
    "moduleTitle.main_award_leader": "moduleTitle.main_award_leader",
    "label.bulk_action_successful": "label.bulk_action_successful",
    "tasks.clear_email_revision": "tasks.clear_email_revision",
    "table.preparation": "table.preparation",
    "table.delete": "table.delete",
    "label.safeguarding_policy": "label.safeguarding_policy",
    "sidebar.reports": "sidebar.reports",
    "pageTitle.sub_global_operating_partners": "pageTitle.sub_global_operating_partners",
    "label.is_major_activity_confirmation": "label.is_major_activity_confirmation",
    "pageTitle.operating_authorities": "pageTitle.operating_authorities",
    "label.delete_participant_award_modal_question_detail": "label.delete_participant_award_modal_question_detail",
    "label.confirmed": "label.confirmed",
    "notifications.invitation_has_been_sent": "notifications.invitation_has_been_sent",
    "pageTitle.independent_countries": "pageTitle.independent_countries",
    "label.assessors_email": "label.assessors_email",
    "tasks.approve_assessor_registration": "tasks.approve_assessor_registration",
    "table.award_duration": "table.award_duration",
    "notifications.organization_has_been_moved": "notifications.organization_has_been_moved",
    "pageTitle.nao_payment": "pageTitle.nao_payment",
    "participant.history_log": "participant.history_log",
    "label.rejected_with_note": "label.rejected_with_note",
    "label.already_running": "label.already_running",
    "button.continue": "button.continue",
    "award.no_data_to_show": "award.no_data_to_show",
    "participant.send_email_invitation_again_question": "participant.send_email_invitation_again_question",
    "label.reason_for_changing_assessor": "label.reason_for_changing_assessor",
    "button.delete": "button.delete",
    "moduleTitle.requirements_and_conditions": "moduleTitle.requirements_and_conditions",
    "roles.leader": "roles.leader",
    "label.if_download_doesnt": "label.if_download_doesnt",
    "dashboard.your_todo_list": "dashboard.your_todo_list",
    "notifications.award_unit_has_been_returned": "notifications.award_unit_has_been_returned",
    "moduleTitle.participant_activities": "moduleTitle.participant_activities",
    "errors.qualification_or_experience_required": "errors.qualification_or_experience_required",
    "label.active_leaders": "label.active_leaders",
    "aj.preparation": "aj.preparation",
    "button.change_state": "button.change_state",
    "label.current_password": "label.current_password",
    "pageTitle.global_operating_partners": "pageTitle.global_operating_partners",
    "moduleTitle.contact_settings": "moduleTitle.contact_settings",
    "button.remove_photo": "button.remove_photo",
    "notifications.activity_has_been_setup": "notifications.activity_has_been_setup",
    "errors.must_be_more_than": "errors.must_be_more_than",
    "table.goal": "table.goal",
    "notifications.coordinator_has_been_set": "notifications.coordinator_has_been_set",
    "label.cc": "label.cc",
    "label.duration": "label.duration",
    "table.actions": "table.actions",
    "participant.send_email_invitation_again": "participant.send_email_invitation_again",
    "moduleTitle.would_you_like_to_remove_participant": "moduleTitle.would_you_like_to_remove_participant",
    "parentalConsent.i_authorise_employees": "parentalConsent.i_authorise_employees",
    "button.reload_page": "button.reload_page",
    "moduleTitle.update_translations": "moduleTitle.update_translations",
    "label.report_description": "label.report_description",
    "table.email": "table.email",
    "label.new_goal": "label.new_goal",
    "label.participant_survey_parent": "label.participant_survey_parent",
    "errors.invalid_email_address": "errors.invalid_email_address",
    "pageTitle.new_contact": "pageTitle.new_contact",
    "sidebar.gops": "sidebar.gops",
    "button.manage_participants": "button.manage_participants",
    "errors.invalid_phone_format": "errors.invalid_phone_format",
    "notifications.login_details_have_been_changed": "notifications.login_details_have_been_changed",
    "moduleTitle.participant_logs": "moduleTitle.participant_logs",
    "label.save": "label.save",
    "label.frequently_asked_questions": "label.frequently_asked_questions",
    "label.city": "label.city",
    "notifications.configuration_value_has_been_reset": "notifications.configuration_value_has_been_reset",
    "states.office_sign_off": "states.office_sign_off",
    "button.save": "button.save",
    "button.import_data_from_selected_file": "button.import_data_from_selected_file",
    "parentalConsent.i_understand_that_the_participant_cannot": "parentalConsent.i_understand_that_the_participant_cannot",
    "pageTitle.apiKeys": "pageTitle.apiKeys",
    "label.international_region": "label.international_region",
    "tabs.levels": "tabs.levels",
    "tabs.additional_files": "tabs.additional_files",
    "label.continuation_level": "label.continuation_level",
    "table.adventurous_journey_detail": "table.adventurous_journey_detail",
    "button.set": "button.set",
    "label.i_certify_that_as_the_assessor": "label.i_certify_that_as_the_assessor",
    "table.coordinator": "table.coordinator",
    "participant.send_confirmation_email_again": "participant.send_confirmation_email_again",
    "table.report": "table.report",
    "label.update_translations_results": "label.update_translations_results",
    "table.observation_note": "table.observation_note",
    "label.view_more": "label.view_more",
    "notifications.payment_link_has_been_reset": "notifications.payment_link_has_been_reset",
    "table.type": "table.type",
    "moduleTitle.updateConfigurationKey": "moduleTitle.updateConfigurationKey",
    "sidebar.independent_award_centers": "sidebar.independent_award_centers",
    "table.activity_type": "table.activity_type",
    "label.awardMode.online": "label.awardMode.online",
    "table.data_state": "table.data_state",
    "button.generate_report": "button.generate_report",
    "moduleTitle.assessed_by_award_leader": "moduleTitle.assessed_by_award_leader",
    "table.child_protection_number": "table.child_protection_number",
    "button.bulk_change": "button.bulk_change",
    "label.send_welcome_email": "label.send_welcome_email",
    "label.award_state": "label.award_state",
    "moduleTitle.overview": "moduleTitle.overview",
    "table.aj_detail": "table.aj_detail",
    "pageTitle.tasks_activity_approvals": "pageTitle.tasks_activity_approvals",
    "label.section": "label.section",
    "route.history": "route.history",
    "route.event_participants": "route.event_participants",
    "participant.account_detail": "participant.account_detail",
    "route.dashboard": "route.dashboard",
    "table.payments": "table.payments",
    "pageTitle.profile": "pageTitle.profile",
    "organisation.remove_organisation": "organisation.remove_organisation",
    "pageTitle.my_organization": "pageTitle.my_organization",
    "label.award_leader": "label.award_leader",
    "notifications.assessor_has_been_updated": "notifications.assessor_has_been_updated",
    "label.participant_personal_reflection": "label.participant_personal_reflection",
    "button.add_key": "button.add_key",
    "header.appMotto": "header.appMotto",
    "table.qualifying": "table.qualifying",
    "button.upload": "button.upload",
    "button.resend": "button.resend",
    "label.filename": "label.filename",
    "label.change_parental_consent": "label.change_parental_consent",
    "button.cancel": "button.cancel",
    "label.aply_to_all_langs": "label.aply_to_all_langs",
    "route.customization": "route.customization",
    "errors.minimal_duration_is": "errors.minimal_duration_is",
    "label.email_help_participant_first_name": "label.email_help_participant_first_name",
    "label.participant_status": "label.participant_status",
    "award.bronze_level_short": "award.bronze_level_short",
    "label.phone_type": "label.phone_type",
    "global.night": "global.night",
    "button.adventurous_journey_settings": "button.adventurous_journey_settings",
    "participant.leader_must_be_selected": "participant.leader_must_be_selected",
    "pageTitle.translationsManagement": "pageTitle.translationsManagement",
    "moduleTitle.user_added_preparation_and_training": "moduleTitle.user_added_preparation_and_training",
    "table.approve": "table.approve",
    "label.role_in_organisation": "label.role_in_organisation",
    "states.finished": "states.finished",
    "label.created": "label.created",
    "button.back_to_home": "button.back_to_home",
    "label.options": "label.options",
    "contact.next_level_invitation": "contact.next_level_invitation",
    "moduleTitle.activity_detail": "moduleTitle.activity_detail",
    "route.section_signoff": "route.section_signoff",
    "moduleTitle.assign_labels_bulk": "moduleTitle.assign_labels_bulk",
    "button.contact_settings": "button.contact_settings",
    "label.transation_id": "label.transation_id",
    "notifications.activity_has_been_updated": "notifications.activity_has_been_updated",
    "sidebar.awards": "sidebar.awards",
    "parentalConsent.images_consent": "parentalConsent.images_consent",
    "participant.would_you_like_to_delete": "participant.would_you_like_to_delete",
    "roles.user": "roles.user",
    "label.label": "label.label",
    "label.select_sheet": "label.select_sheet",
    "global.no_results": "global.no_results",
    "moduleTitle.address_line_2": "moduleTitle.address_line_2",
    "states.awaiting_office_sign_off": "states.awaiting_office_sign_off",
    "moduleTitle.export": "moduleTitle.export",
    "moduleTitle.address_line_1": "moduleTitle.address_line_1",
    "notifications.participant_has_been_assigned": "notifications.participant_has_been_assigned",
    "roles.viewer": "roles.viewer",
    "label.participants_total": "label.participants_total",
    "errors.auth_code_is_no_longer_valid": "errors.auth_code_is_no_longer_valid",
    "label.file_is_not_available": "label.file_is_not_available",
    "button.select_template": "button.select_template",
    "label.payment": "label.payment",
    "award.silver_level_short": "award.silver_level_short",
    "table.participant_id": "table.participant_id",
    "text.hours_old": "text.hours_old",
    "moduleTitle.your_personal_information": "moduleTitle.your_personal_information",
    "aj.minimum_date_recommendation": "aj.minimum_date_recommendation",
    "label.date_of_payment": "label.date_of_payment",
    "button.view": "button.view",
    "label.create_new_label": "label.create_new_label",
    "title.confirmation": "title.confirmation",
    "button.set_participants": "button.set_participants",
    "roles.assessor": "roles.assessor",
    "moduleTitle.coordinator_settings": "moduleTitle.coordinator_settings",
    "label.parent_relationship": "label.parent_relationship",
    "table.nao": "table.nao",
    "notifications.email_has_been_sent": "notifications.email_has_been_sent",
    "label.email_help_participant_full_name": "label.email_help_participant_full_name",
    "sidebar.suboperating_authorities": "sidebar.suboperating_authorities",
    "route.award": "route.award",
    "label.no_roles": "label.no_roles",
    "table.files": "table.files",
    "aj.minimum_date_requirements": "aj.minimum_date_requirements",
    "pageTitle.labels": "pageTitle.labels",
    "label.participant_is_semi_offline": "label.participant_is_semi_offline",
    "moduleTitle.other_coordinators": "moduleTitle.other_coordinators",
    "button.updateSelectedLanguage": "button.updateSelectedLanguage",
    "tasks.approve_award_registration": "tasks.approve_award_registration",
    "participant.invite_participant_to_next_level": "participant.invite_participant_to_next_level",
    "label.twitter": "label.twitter",
    "pageTitle.awards": "pageTitle.awards",
    "warning.award_marked_as_paid": "warning.award_marked_as_paid",
    "table.edit": "table.edit",
    "states.change_to_state_warning_missing_hours_to_complete": "states.change_to_state_warning_missing_hours_to_complete",
    "label.dofe": "label.dofe",
    "moduleTitle.after_assigning_a_role_to_yourself": "moduleTitle.after_assigning_a_role_to_yourself",
    "label.transaction_id": "label.transaction_id",
    "table.suboperating_authority": "table.suboperating_authority",
    "label.participant_survey": "label.participant_survey",
    "label.created_by": "label.created_by",
    "button.send_confirmation_email_again_question": "button.send_confirmation_email_again_question",
    "label.email_help_award_leader_email": "label.email_help_award_leader_email",
    "label.name": "label.name",
    "tabs.gold_level": "tabs.gold_level",
    "pageTitle.award_documents": "pageTitle.award_documents",
    "label.online_payments": "label.online_payments",
    "label.child_protection_number": "label.child_protection_number",
    "participant.send_password_recovery_email": "participant.send_password_recovery_email",
    "notifications.new_log_has_been_added": "notifications.new_log_has_been_added",
    "moduleTitle.add_gop_role": "moduleTitle.add_gop_role",
    "label.organization_name": "label.organization_name",
    "pageTitle.my_organization_templates": "pageTitle.my_organization_templates",
    "pageTitle.award_leaders": "pageTitle.award_leaders",
    "label.status": "label.status",
    "label.street": "label.street",
    "roles.if_staff_superuser": "roles.if_staff_superuser",
    "table.licence_holder": "table.licence_holder",
    "label.created_at": "label.created_at",
    "table.section": "table.section",
    "table.system_rights": "table.system_rights",
    "label.iac_type": "label.iac_type",
    "label.other": "label.other",
    "moduleTitle.login": "moduleTitle.login",
    "label.no_data_to_show": "label.no_data_to_show",
    "aj.cannot_modify_award_level_if_participants_are_assigned": "aj.cannot_modify_award_level_if_participants_are_assigned",
    "tabs.waiting_payments": "tabs.waiting_payments",
    "global.supervisor": "global.supervisor",
    "notifications.new_role_has_been_added": "notifications.new_role_has_been_added",
    "award.silver_level": "award.silver_level",
    "heading.change_awards_mode": "heading.change_awards_mode",
    "button.save_changes": "button.save_changes",
    "organisation.would_you_like_to_move_award_unit": "organisation.would_you_like_to_move_award_unit",
    "label.fields": "\nlabel.fields",
    "label.email_help_organization_name": "label.email_help_organization_name",
    "pageTitle.mro_related_detail": "pageTitle.mro_related_detail",
    "table.started_at": "table.started_at",
    "parentalConsent.i_consent_to_the_award_unit": "parentalConsent.i_consent_to_the_award_unit",
    "logs.minutes": "logs.minutes",
    "label.total_participants": "label.total_participants",
    "moduleTitle.contact_info": "moduleTitle.contact_info",
    "table.payment_link": "table.payment_link",
    "errors.please_contact_your_local_award_staff": "errors.please_contact_your_local_award_staff"
}